import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e3a84bf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "book-history-detail" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createVNode($setup["NavigationBar"], { title: "예약내역" }),
      _createElementVNode("div", {
        class: "book-history-container",
        onTouchstart: $setup.onTouchStart,
        onTouchend: $setup.onTouchEnd
      }, [
        (_openBlock(), _createElementBlock("div", {
          class: "segmented-control",
          key: $setup.updateKey
        }, [
          _createVNode($setup["SegmentedControl"], {
            ref: "segmentedControl",
            segments: $setup.segmentTitles,
            initialIndex: $setup.currentSegmentIndex,
            onOnChangedSegmentIndex: $setup.onChangedSegmentIndex
          }, null, 8 /* PROPS */, ["initialIndex"])
        ])),
        _createVNode($setup["BookHistoryTable"], {
          bookInfos: $setup.currentBookInfos,
          shouldShowFilterMenu: $setup.shouldShowFilterMenu,
          filterDisplayText: $setup.getCurrentFilterString(),
          onOnClickFilter: $setup.showFilterModal,
          onOnSelectBookInfo: $setup.showBookHistoryDetail
        }, null, 8 /* PROPS */, ["bookInfos", "shouldShowFilterMenu", "filterDisplayText"])
      ], 32 /* NEED_HYDRATION */),
      ($setup.shouldShowFilters)
        ? (_openBlock(), _createBlock($setup["FilterModal"], {
            key: 0,
            filters: $setup.filters,
            initialAppliedFilters: $setup.currentFilters,
            onOnClickClose: _cache[0] || (_cache[0] = ($event: any) => ($setup.shouldShowFilters = false)),
            onOnClickApply: $setup.onFilterChanged
          }, null, 8 /* PROPS */, ["filters", "initialAppliedFilters"]))
        : _createCommentVNode("v-if", true),
      _createVNode($setup["PageModal"], {
        shouldShow: $setup.shouldShowBookHistoryDetail,
        onBackHandler: () => $setup.toggleShowBookHistoryDetail(false)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode($setup["BookHistoryDetail"], {
              bookInfo: $setup.selectedBookInfo!,
              turnId: $setup.selectedBookInfo!.turnId,
              oneTimeFare: $setup.selectedBookInfo!.bookAmount,
              onOnClickClose: _cache[1] || (_cache[1] = ($event: any) => ($setup.toggleShowBookHistoryDetail(false))),
              onOnCompleteBookCancel: $setup.onCompleteBookCancel
            }, null, 8 /* PROPS */, ["bookInfo", "turnId", "oneTimeFare"])
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["shouldShow", "onBackHandler"])
    ]),
    _: 1 /* STABLE */
  }))
}